import { useCallback, useState } from 'react'
import { GameSection, InterludeSection, NPCDialog, SectionType, TextScreen } from '../../game/types'
import './level.css'
import { useAtomValue, useSetAtom } from 'jotai'
import { currentProgressAtom, progressDispatchAtom } from '../state/state'

import { UserOptionQuestion } from '../../game/types'
import { userAtom } from '../state/user'
interface LevelProps {

    currentSection: GameSection,
    goToNextSection: () => void

}

interface InterludeSectionProps {
    currentSection: InterludeSection,
    goToNextSection: () => void
}

const InterludeSectionView = ({currentSection, goToNextSection}: InterludeSectionProps) => {

    // Within a given section; we progress through internal screens. 

    // I don't LOVE that term. I think what would be better is to have something ENTIRELY capable of handling "level" like things. 

    // This should delegate to a sub-thing that handles the section rendering. 

    // TODO @Marcel: Move this somewhere internal higher up. 
    // const [sectionIdx, setSectionIdx] = useState(0)
    const progress = useAtomValue(currentProgressAtom)
    const dispatchProgress = useSetAtom(progressDispatchAtom)

    const currentScreen = currentSection.screens[progress.frame]

    const progressScene = useCallback((e: any) => {
        e.preventDefault()

        // Don't allow direct screen progression when there's a user prompt present 
        if (currentScreen.userOptionQuestion) {
            return
        }

        if ((currentSection.screens.length-1)> progress.frame) {
            dispatchProgress({type: "GO_TO_NEXT_FRAME"})
        }
        else {
            goToNextSection();
        }

    }, [currentScreen, dispatchProgress, goToNextSection, progress.frame, currentSection.screens.length])

    return <div
        onClick={progressScene}
    >
        {currentSection.screens && currentScreen && <LevelSection info={currentScreen}/>}

    </div>

}

const Level = (({currentSection, goToNextSection}: LevelProps) => {

    return <>
        {currentSection.type === SectionType.INTERLUDE ? 
            <InterludeSectionView currentSection={currentSection} goToNextSection={goToNextSection}/> : 
            <></>
        }
    
    </>

})

export default Level;

interface LevelSectionProps {
    info: TextScreen
}

const LevelSection = ({ info }: LevelSectionProps) => {

    return <div className="levelSection">

        {info.text && <div className={'interludeTextContainer' + (info.text.style === "LevelTitle" ? " levelTitle": "")}>{info.text.t}</div>}

        {/* Render img div */}
        {info.image &&
            
            <img className="interludeImgContainer"
                src = {info.image}
                alt='game img'
            />
        
        }

        <div className='dialogPositioner'>
            {info.npcDialog && <NPCDialogCard dialog={info.npcDialog}/>}
            {info.userOptionQuestion && <UserChoiceCard question={info.userOptionQuestion}/>}
        </div>

    </div>

}




const UserChoiceCard = ({ question} : { question: UserOptionQuestion}) => {

    const user = useAtomValue(userAtom)
    const dispatchProgress = useSetAtom(progressDispatchAtom)

    return <div className='npcDialogCard userChoiceCard'>

        <img
            src={user.profileImg}
            alt='user profile img'
        />

        <p>
            {question.prompt}
        </p>

        {question.options.map((option, idx) => {
            return <button key={idx} onClick={(e) => {
                e.preventDefault()
                dispatchProgress({type: "JUMP_TO_FRAME", frameUID: option.navToFrameUid})
            }}>
                {option.text}
            </button>
        })}

    </div>

}

const NPCDialogCard = ({ dialog} : { dialog: NPCDialog}) => {

    return <div className='npcDialogCard'>

        <img
            src={dialog.person.image}
            alt={dialog.person.name}
        />

        <p>
            {dialog.dialog}
        </p>

    </div>

}